import "./index.css";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import App from "./App";
import dotenv from "dotenv";
import React from "react";
import ReactDOM from "react-dom";
import keycloakService from "./services/keycloakService";

const renderApp = () => ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

//console.log("forceDeploy");
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
dotenv.config();
keycloakService.initKeycloak(renderApp);